import React, { Fragment, Component, useRef, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import data from '../data/portfolio.json'; // This is in the public directory
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';
import { NavLink } from 'react-router-dom';

var thisDesign;
var getPortID;
  // SCROLLING ANIMATION
  gsap.registerPlugin(ScrollTrigger);

const PortfolioDetails = () => {
	const [portfolio, setPortfolio] = useState([]);
	const navigate = useNavigate();
	const { design_slug } = useParams();



	useGSAP(() => {

         // preventive
        sScroll.scrollTo(0, false);

         const fetchPortfolio = async () => {
        //GET DATA 
         function findId(data, idToLookFor) {
            var categoryArray = data;
            for (var i = 0; i < categoryArray.length; i++) {
                if (categoryArray[i].design_id == idToLookFor) {
                    return(categoryArray[i]);
                }
            }
        }
        

   getPortID = parseInt(design_slug.match(/\d+$/));
   thisDesign = findId(data, getPortID);
     setPortfolio(thisDesign);

     };
		fetchPortfolio();


// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
// INITIAL ANIMATION
// = .port-back-btn
// = .pdp-info-window
// = pdp-info-window strong
// = pdp-info-window p



gsap.set(".port-back-btn", { opacity: 0 });
gsap.set(".pdp-info-window h2", {opacity: 0 });
gsap.set(".pdp-info-window", { rotationY: -10, rotationX: -10, opacity: 0,  perspective: 500, transformStyle: "preserve-3d" });
gsap.set(".pdp-info-window strong, .pdp-info-window p", {y:10, opacity: 0 });

let tl_details_ui = gsap.timeline({});

tl_details_ui 
  .to(".port-back-btn", {opacity: 1, duration:1 })
  .to(".pdp-info-window", { rotationY: 0, rotationX: 0, opacity: 1, duration:0.5,   transformOrigin: "center center",})
  .to(".pdp-info-window h2", { opacity: 1,  duration:1, delay:-0.25, onComplete: infoContentShow});

function infoContentShow() {
  // Grabs all strong and p tags top-to-bottom in exact DOM order
  gsap.to(".pdp-info-window strong, .pdp-info-window p", {
    y:0,
    opacity: 1,
    duration: 0.25,      // Quick fade time per element
    stagger: 0.08,       // Delay between each item starting (lower = faster)
    ease: "power1.out"
  });
}




// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
// I M A G E   P R E L O A D E R
// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

// Import Images To Pre load Here
let details_page_image_1 = thisDesign.design_file_path_1; 
let details_page_image_2 = thisDesign.design_file_path_2;
let details_page_image_3 = thisDesign.design_file_path_3; 
let details_page_image_4 = thisDesign.design_file_path_4; 
let details_page_image_5 = thisDesign.design_file_path_5; 


function preloadImagesPortfolio(portUrls, allImagesLoadedCallback) {
  let portLoadedCounter = 0;
  const portToBeLoadedNumber = portUrls.length;

  // 1. Setup states dynamically: Hide ALL image containers first, then reveal active ones
  for (let i = 1; i <= 5; i++) {
    const preloader = document.querySelector(`.port-preloader-${i}`);
    const imgWrapper = document.querySelector(`.port-img-0${i}`);
    const imgElement = document.querySelector(`.port-img-0${i} img`);

    if (i <= portToBeLoadedNumber) {
      // Slot is ACTIVE: Show wrapper & preloader, keep <img> hidden
      if (imgWrapper) gsap.set(imgWrapper, { display: "block" });
      if (preloader) gsap.set(preloader, { display: "block", opacity: 1 });
      if (imgElement) gsap.set(imgElement, { opacity: 0 });
    } else {
      // Slot is UNUSED: Explicitly strip display from wrapper and preloader
      if (imgWrapper) gsap.set(imgWrapper, { display: "none" });
      if (preloader) gsap.set(preloader, { display: "none", opacity: 0 });
    }
  }

  // 2. Loop through URLs with their actual index
  portUrls.forEach(function(url, index) {
    const id = index + 1; 
    const preloader = document.querySelector(`.port-preloader-${id}`);
    const imgContainerWrapper = document.querySelector(`.port-img-0${id}`);
    const imgElement = document.querySelector(`.port-img-0${id} img`);

    preloadImage(url, imgElement, imgContainerWrapper, function() {
      portLoadedCounter++;
      console.log(`Image ${id} finished loading. Total loaded: ${portLoadedCounter}`);

      // Handle individual animation safely for THIS specific image when it's ready
      if (preloader && imgElement) {
        let tl_port_img_preloader = gsap.timeline({});
        tl_port_img_preloader.to(preloader, { duration: 1.5, opacity: 0 })
          .to(imgElement, { duration: 0.5, opacity: 1, delay: -0.25 }, "-=0.25")
          .call(() => {
            preloader.classList.add("pausespinner");
          });
      }

      // Check if all images are fully finished
      if (portLoadedCounter === portToBeLoadedNumber) {
        allImagesLoadedCallback();
      }
    });
  });

  function preloadImage(url, imgElement, imgContainerWrapper, anImageLoadedCallback) {
    var img = new Image();
    let dimensionsApplied = false;

    // Helper function to set attributes & aspect ratio on container + image
    function applyDimensions(w, h) {
      if (dimensionsApplied || !imgElement) return;
      dimensionsApplied = true;

      const aspectRatio = `${w} / ${h}`;

      // 1. Apply aspect-ratio to the parent wrapper container to instantly hold space
      if (imgContainerWrapper) {
        imgContainerWrapper.style.aspectRatio = aspectRatio;
      }

      // 2. Set HTML width, height, and CSS aspect-ratio on the <img> tag
      imgElement.setAttribute("width", w);
      imgElement.setAttribute("height", h);
      imgElement.style.aspectRatio = aspectRatio;

      // 3. Assign the URL src to the target <img> if it hasn't been set yet
      if (!imgElement.src || imgElement.src !== url) {
        imgElement.src = url;
      }
    }

    // Fast-poll every 10ms for metadata dimensions before full file download
    const pollDimensions = setInterval(() => {
      if (img.naturalWidth > 0 && img.naturalHeight > 0) {
        clearInterval(pollDimensions);
        applyDimensions(img.naturalWidth, img.naturalHeight);
      }
    }, 10);

    img.onload = function() {
      clearInterval(pollDimensions);
      // Guarantee dimensions are set even if fast-polling was bypassed (e.g. from cache)
      applyDimensions(img.naturalWidth, img.naturalHeight);
      anImageLoadedCallback();
    };

    img.onerror = errorCallback;
    img.src = url;
    
    function errorCallback() {
      clearInterval(pollDimensions);
      console.warn("Failed to load image: " + url);
      anImageLoadedCallback(); 
    }
  }
}

// Let's call it:
preloadImagesPortfolio([
  details_page_image_1,
  details_page_image_2,
  details_page_image_3,
  details_page_image_4,
  details_page_image_5
].filter(Boolean), function() {
  console.log('All Portfolio Details Panel images were successfully loaded');
});
  // EOF Image Preloader >>>>>>>>>>
// ############################## >>






// URL LINK DETECTOR
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 // 1. Find all your link containers
  const containers = document.querySelectorAll(".portfolio-url-link");
  
  containers.forEach(container => {
    const link = container.querySelector("a");
    if (!link) return;

    const linkText = link.textContent.trim().toLowerCase();
    
    // 2. Check the real DOM text right inside GSAP
    if (!linkText || linkText === "none" || linkText === "null" || linkText.includes("undefined")) {
      // Use GSAP to kill the display property cleanly so it doesn't fight with animations
      gsap.set(container, { display: "none", opacity: 0, pointerEvents: "none" });
    } else {
      gsap.set(container, { display: "block" }); // Or "flex", depending on your layout
    }
  });







    
      
}, {  dependencies: [portfolio]  }); 
// End of useGSAP
  


  
 


return (


<main className="page-content page-id_portfolio-details" data-page-id="portfolio-details">
<HelmetProvider>
<Fragment> 
      <Helmet>  
       
        <title>MHD | {portfolio.design_type  + ' - ' +  portfolio.design_client}</title>
        <meta name="description" content={portfolio.design_desciption}/>
      </Helmet>
    </Fragment>
</HelmetProvider>

    <div className="content portfolio-details-container">

     <div className="title-bar">














       

   <div className="port-back-btn-top-wrapper">
     <div className="port-back-btn-top">
    <NavLink to="/portfolio" className="port-back-btn">Close</NavLink>
     </div>
       </div>


       <h1 className="page-h1">
           <span className="title-type">{portfolio.design_type }</span>
           <span className="title-dash"> - </span>
           <span className="title-client">{portfolio.design_client}</span> 
            </h1>
  
      </div>
 
      <div className="portfolio-display-panel">
        <div className="pdp-content">

           <div className="port-img-01">
              <img src={portfolio.design_file_path_1} alt="portfolio image one" />
              <div className="port-preloader-1"></div>
           </div>

           <div className="port-img-02">
            <img src={portfolio.design_file_path_2} alt="portfolio image two" />
            <div className="port-preloader-2"></div>
          </div>

          <div className="port-img-03">
            <img src={portfolio.design_file_path_3} alt="portfolio image three" />
            <div className="port-preloader-3"></div>
         </div>

  <div className="port-img-04">
    <img src={portfolio.design_file_path_4} alt="portfolio image four" />
    <div className="port-preloader-4"></div>
  </div>

  <div className="port-img-05">
    <img src={portfolio.design_file_path_5} alt="portfolio image five" />
    <div className="port-preloader-5"></div>
  </div>







</div>
<div className="pdp-info">
  <div className="pdp-info-window" data-speed="1">
    <h2>Design Details</h2>
             <div clasName="pdp-info-grid">
                 <div className="info-sect-1"><strong>Design Description</strong> <p>{portfolio.design_description}</p></div>
                 <div className="info-sect-2"><strong>Design ID</strong> <p>{portfolio.design_id}</p></div>
                 <div className="info-sect-3"><strong>Design Category</strong> <p>{portfolio.design_category}</p></div>
                 <div className="info-sect-4"><strong>Design Type</strong> <p>{portfolio.design_type}</p></div>
                 <div className="info-sect-5"><strong>Client</strong> <p>{portfolio.design_client}</p></div>
                 <div className="info-sect-6"><strong>Design Tools</strong> <p>{portfolio.design_tools}</p></div>
                 <div className="info-sect-7"><strong>Design Date</strong> <p>{portfolio.design_date}</p></div>
                 <div className="info-sect-8"><strong>Design Keywords</strong> <p>{portfolio.design_keywords}</p></div>
             </div>



  <div className="portfolio-url-link">
    <strong>Design Link</strong> 
    <p>
      <a href={portfolio.design_link} target="_blank" rel="noreferrer">
        {portfolio.design_link}
      </a>
    </p>
  </div>






                      </div>
                </div>
     </div>


<NavLink to="/portfolio" className="port-back-btn bottom">Close</NavLink>








		</div>
    </main>


	);
};
export default PortfolioDetails;



 







